import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

export const StickyMobileCTA = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/95 backdrop-blur border-t border-[hsl(var(--border))] px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <div className="flex gap-2">
        <Link to="/contact" className="flex-1">
          <Button className="w-full bg-[hsl(var(--sss-coral))] hover:bg-[hsl(var(--sss-coral-2))] text-white rounded-xl h-10 text-sm font-medium shadow-sm">
            Book a Demo
          </Button>
        </Link>
        <a href="https://approvemysmile.com/register/personal" target="_blank" rel="noopener noreferrer" className="flex-1">
          <Button variant="outline" className="w-full border-[hsl(var(--sss-navy))] text-[hsl(var(--sss-navy))] rounded-xl h-10 text-sm font-medium">
            Get Started
          </Button>
        </a>
      </div>
    </div>
  );
};
